import {
    deleteAccountApplication,
    fetchAccountApplication,
    saveAccountApplication,
    updateAccountApplication,
} from '../reducers/recordsSlice';
import {recordSelector} from '../selectors';
import {
    useAppDispatch,
    useAppSelector
} from '../../../../hooks/useTypedReactRedux';
import {AccountApplication} from '../types';

export const useAccountApplication = (accountId: string, accountApplicationId?: string) => {

    if (!accountId) {
        throw new Error('accountId is required parameter')
    }

    const dispatch = useAppDispatch();

    const {
        record,
        loading,
    } = useAppSelector((state) =>
                           recordSelector(state, accountApplicationId ? accountApplicationId : ''),
    );

    // FETCH
    const fetchRecord = () => {
        if (typeof accountApplicationId === 'undefined') {
            throw new Error('accountApplicationId is required parameter');
        }
        dispatch(fetchAccountApplication({
                                             id: accountApplicationId
                                         }));
    };

    // CREATE, UPDATE DELETE
    const createRecord = (values: AccountApplication) => {
        dispatch(saveAccountApplication({
                                            payload: values
                                        }));
    };

    const updateRecord = (values: AccountApplication) => {
        if (typeof accountApplicationId === 'undefined') {
            throw new Error('accountApplicationId is required parameter');
        }

        dispatch(updateAccountApplication({
                                              id: accountApplicationId,
                                              record: values,
                                          }));
    };

    const deleteRecord = () => {
        if (typeof accountApplicationId === 'undefined') {
            throw new Error('accountApplicationId is required parameter');
        }
        dispatch(deleteAccountApplication({
                                              id: accountApplicationId
                                          }));

    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
